function catalogMenuMobile() {
   const selectCatalog = document.querySelector('.catalog-menu__select'),
       selectCatalogName = document.querySelector('.catalog-menu__select span'),
       closeCatalogMenu = document.querySelector('.catalog-menu__list-close'),
       catalogTitle = document.querySelector('.catalog-title'),
       menu = document.querySelector('.catalog-menu__list');

   if (selectCatalogName) {
       selectCatalogName.innerHTML = catalogTitle.textContent;
   }

   selectCatalog?.addEventListener('click', () => {
       menu.classList.add('active');
       document.body.style.overflow="hidden";
   })

   closeCatalogMenu?.addEventListener('click', () => {
       menu.classList.remove('active');
       document.body.style.overflow="visible";
   })
}

export default catalogMenuMobile;
